<template>
  <div id="element-to-print">
    <product-spec ref="productDetail"/>
  </div>
</template>

<script>
  import ProductSpec from '@/components/ProductSpec'

  export default {
    name: 'ProductSpecPage',
    components: {
      ProductSpec,
    },
    computed: {
      slug: function () {
        return this.$route.params.slug;
      }
    },
    methods: {
      load: function () {
        const slug = this.slug;

        this.$root.$api.getProductBySlug(slug)
          .then(response => {
            if (response.data != null) {
              this.product = response.data.products[0];
              this.$refs.productDetail.loadProduct(this.product);
            }
          }).catch(error => {
          console.log(error);
        })
      }
    },
    created: function () {
      this.load();
    }
  };
</script>
